module.exports = __webpack_public_path__ + "img/abnormalAssetsRegistration.796dc253.svg";